import { Link } from "react-router-dom";

export const Footer = () => {
  return (
  <footer className="bg-night text-[#FFFFFF]" data-testid="site-footer">
    <div className="w-full px-5 md:px-8 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-7">
          <p className="font-serif text-3xl md:text-4xl tracking-tight">Les Mots pour le Dire</p>
          <p className="mt-7 font-serif italic text-2xl md:text-[1.75rem] leading-snug text-[#FFFFFF]/85 max-w-md md:ml-16">
            « Il faut avec les mots de tout le monde,
            <br />
            écrire comme personne… »
          </p>
        </div>

        <div className="md:col-span-4 md:col-start-9">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#FFFFFF]/50">Contact</p>
          <ul className="mt-5 space-y-3 text-sm text-[#FFFFFF]/80">
            <li className="text-[#FFFFFF]">Carole Bourbasquet</li>
            <li>
              <a href="tel:+33603274610" data-testid="footer-phone-link" className="hover:text-[#FFFFFF] transition-colors duration-300">
                06 03 27 46 10
              </a>
            </li>
            <li>
              <a href="mailto:contact@lesmots-pourledire.fr" data-testid="footer-email-link" className="hover:text-[#FFFFFF] transition-colors duration-300 break-all">
                contact@lesmots-pourledire.fr
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-20 md:mt-28 pt-8 border-t border-[#FFFFFF]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-[#FFFFFF]/60">
          © {new Date().getFullYear()} Les Mots pour le Dire — Créé par l'agence{" "}
          <a
            href="https://www.thehillproject.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-hill-project-link"
            className="underline underline-offset-4 hover:text-[#FFFFFF] transition-colors duration-300"
          >
            THE HILL PROJECT
          </a>
        </p>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <Link
            to="/mentions-legales"
            data-testid="footer-mentions-link"
            className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FFFFFF]/50 hover:text-[#FFFFFF] transition-colors duration-300"
          >
            Mentions légales
          </Link>
          <Link
            to="/politique-de-confidentialite"
            data-testid="footer-confidentialite-link"
            className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FFFFFF]/50 hover:text-[#FFFFFF] transition-colors duration-300"
          >
            Politique de confidentialité
          </Link>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FFFFFF]/50 hover:text-[#FFFFFF] transition-colors duration-300"
          >
            Espace admin
          </Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
